module.exports = __webpack_public_path__ + "bb69c4ca67a7cefce560905ec6b55359.svg";